<script>
export default {
  name: 'Test',
  components: {
    Layout: () => import('@layouts/main'),
    TablePaginator: () => import('@components/paginator'),
  },
  data() {
    return {
      headers: [
        { text: 'type', value: 'type', sortable: true, width: '10%' },
        { text: 'number', value: 'number', sortable: true, width: '10%' },
        { text: 'date', value: 'date', sortable: true, width: '10%' },
        { text: 'from', value: 'from', sortable: true, width: '10%' },
        {
          text: 'fromWarehouse',
          value: 'fromWarehouse',
          sortable: true,
          width: '10%',
        },
        { text: 'to', value: 'to', sortable: true, width: '10%' },
        {
          text: 'toWarehouse',
          value: 'toWarehouse',
          sortable: true,
          width: '10%',
        },
        { text: 'status', value: 'status', sortable: true, width: '10%' },
        { text: 'owner', value: 'ownerId', sortable: true, width: '10%' },
        { text: 'actions', value: 'actions', sortable: false, width: '10%' },
      ],
      content: [],
      pagination: {},
      first: false,
      last: false,
      totalPages: 5,
      rowsPerPage: [10, 25, 50],
      page: 1,
      sortBy: 'number',
      descending: true,
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
      }
    },
  },
  watch: {
    pagination: {
      handler(value) {
        this.$store.commit('pagination/SET', {
          name: 'test',
          pagination: value,
        })
      },
      deep: true,
    },
  },
  mounted() {
    this.setPaginator()
    this.getData()
  },
  methods: {
    getData(sorting = null) {
      const payload = {
        name: this.$route.params.documentType || null,
        params: this.params,
      }
      this.$store.dispatch('data/fetchData', payload).then(response => {
        this.content = response.content
        this.totalPages = response.totalPages
        this.first = response.first
        this.last = response.last
        this.page = response.number + 1
        this.pagination = {
          ...this.pagination,
          page: 1,
          rowsPerPage: response.size,
          sortBy: this.sortBy,
          descending: this.descending,
        }
      })
    },
    setPaginator() {
      const pagination = this.$store.getters['pagination/get']('test')
      if (pagination)
        this.pagination = {
          ...pagination,
        }
      else
        this.pagination = {
          page: 1,
          rowsPerPage: 10,
          sortBy: this.sortBy,
          descending: this.descending,
        }
    },
    changePage(value) {
      this.page = value
      this.getData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.getData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.getData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
  },
}
</script>

<template>
  <Layout>
    <div>
      <v-data-table
        :headers="headers"
        :items="content"
        :pagination="pagination"
        hide-actions>
        <template 
          slot="headers" 
          slot-scope="props">
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="getSortClass(header)"
              style="text-align: left"
              @click="changeSort(header)"
            >
              {{ $t(`label__${header.text}`) }}
              <v-icon 
                v-if="header.sortable" 
                small>expand_less</v-icon>
            </th>
          </tr>
        </template>
        <template 
          slot="items" 
          slot-scope="props">
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.number }}</td>
          <td>{{ props.item.date }}</td>
          <td>{{ props.item.from }}</td>
          <td>{{ props.item.fromWarehouse }}</td>
          <td>{{ props.item.type === 5 ? '-' : props.item.to }}</td>
          <td>{{ props.item.type === 5 ? '-' : props.item.toWarehouse }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.ownerId }}</td>
          <td>X</td>
        </template>
      </v-data-table>
      <table-paginator
        :page="page"
        :total-pages="totalPages"
        :first="first"
        :last="last"
        :rows-per-page="pagination.rowsPerPage"
        @change-page="changePage($event)"
        @change-rows-per-page="changeRowsPerPage($event)" />
    </div>
  </Layout>
</template>
